import React, {Component} from 'react';
import { connect } from 'react-redux';
import { 
  Layout, 
  Spin, 
  Table, 
  Row, 
  Col, 
  Tag, 
  Button, 
  Tooltip, 
  Form,
  Modal, 
  Input, 
  Divider, 
  PageHeader,
  Breadcrumb 
} from 'antd';
import axios from 'axios';
import Moment from 'react-moment';
import qs from 'qs';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import DropdownCountry from '../SearchForm/dropdown-country';
import { Constant } from '../../config';
import MyModal from '../Modal';

const { Content } = Layout;
Moment.globalLocal = false;
const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Price",
  },
  {
    path: "/country",
    breadcrumbName: "Country Listing",
  },
  {
    path: "",
    breadcrumbName: "Sell Price",
  },
];

class CountrySellPrice extends Component {
	state = {
		loading: false,
		dataSource: [],
    visibleFormModal: false,
    countryData: {}
	}
  authorization = `Bearer ${localStorage.getItem(Constant.SessionKey)}`

	columns = [
		{
      title: 'Country',
      dataIndex: 'name',
      render: (text, record)=>{
        return (
          <span>
            <span style={{fontWeight:'bold'}}>{record.country_name}</span><br />
            <Tag color="blue">Code: {record.region_code}</Tag>
            <Tag color="orange">
              Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Client Rate',
      dataIndex: 'client_rate',
      render: (text, record)=>{
        return (<span>{record.client_rate.toFixed(4)}</span>)
      }
    },
    {
      title: 'Market Rate',
      dataIndex: 'market_rate',
      render: (text, record)=>{
        return (<span>{record.market_rate.toFixed(4)}</span>)
      }
    },
    {
			title: 'Action',
			dataIndex: 'id',
			render: (text, record)=>{
    		return (
          <Tooltip placement="top" title="Edit">
            <Button icon="edit" onClick={()=>this._edit(record)} />
          </Tooltip>
    		)
    	}
		}
  ]
  columnsMobile = [
    {
      title: 'Country',
      dataIndex: 'name',
      render: (text, record)=>{
        return (
          <span>
            <span style={{fontWeight:'bold'}}>{record.country_name}</span><br />
            <Tag color="blue">Code: {record.region_code}</Tag>
            <Tag color="orange">
              Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
            <Divider className="my-divider" dashed orientation="left">Client Rate</Divider>
            <Row><span>{record.client_rate.toFixed(4)}</span></Row>
            <Divider className="my-divider" dashed orientation="left">Market Rate</Divider>
            <Row><span>{record.market_rate.toFixed(4)}</span></Row>
            <Divider className="my-divider" dashed orientation="left">Action</Divider>
            <Row>
              <Tooltip placement="top" title="Edit">
                <Button icon="edit" onClick={()=>this._edit(record)} />
              </Tooltip>
            </Row>
          </span>
        )
      }
    },
  ]
  currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0

	componentWillMount(){
    this.props.fetchMenuAction("country", "country-sell-price")
    this.setState({loading: true})
  }

  async componentDidMount() {
  	this.setState({
  		loading: false,
  		dataSource: await this._getList(),
  	})
  }  

  _edit = async (c) => {
  	this.setState({
      countryData: {
        id: c.id,
        country_name: c.country_name,
      	client_rate: c.client_rate.toFixed(4),
      	market_rate: c.market_rate.toFixed(4),
      },
      visibleFormModal: true
    })
  }

  mySearch = (fd) => {
  	fd.validateFields(async (err, values)=>{
  		if (err)
  			return

      this.setState({loading: true})

	   	this.currentPage = 1
      this.currentSearch = values.country
      this.limit = 10
	    this.setState({
        dataSource: await this._getList(1, 10, this.currentSearch),
        loading: false
      })
  	})
  }

  formHandleSubmit = () => {
  	const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err)
        return

      this.setState({
        visibleFormModal: false,
        loading: true,
      })

      let url = Constant.COUNTRY_SELL_PRICE_EDIT_API.replace("[id]", values.id)
      let opt = {
        url,
        method: "PATCH",
        data: qs.stringify(values),
        headers: {
          'Authorization': this.authorization,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
        MyModal.info(`Sell Price has been updated successfully.`, "", async ()=>{
          this.setState({
            loading: false,
            dataSource: await this._getList(this.currentPage, this.limit, this.currentSearch),
          })
        })
      }
    });
  }

  formHandleCancel = () => {
    const {data: d, form } = this.formRef.props;
    if (form.isFieldsTouched()) {
      form.setFieldsValue(d)
    }
    this.setState({visibleFormModal: false})
  }

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  resetSearch = async () => {
    this.setState({loading: true})
  	this.currentPage = 1
    this.currentSearch = ""
  	this.setState({
      dataSource: await this._getList(1, 10, ""),
      loading: false
    })
  }

  changePage = async (page, limit) => {
    this.setState({loading: true})
  	this.currentPage = page
  	this.limit = limit
  	this.setState({
      dataSource: await this._getList(
        page,
        limit,
        this.currentSearch,
      ),
      loading: false
    })
  }

  _getList = async (page=1, limit=10, region_code="")=>{
  	let url = Constant.COUNTRY_SELL_PRICE_API
    let opt = {
      url,
      method: "GET",
      params: {
        page,
        limit,
        region_code
      },
      headers: {
        'Authorization': this.authorization
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      return []
    }

    if (resp.data.error) {
      return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
  }

	render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize:this.limit, 
        total:this.totalRows, 
        current:this.currentPage, 
        onChange:this.changePage, 
        size:"small"
      },
      bordered: true
    }
    let propsTableForMobile = Object.assign({}, propsTable)
    propsTableForMobile.className = "my-table-mobile"
    propsTableForMobile.columns = this.columnsMobile

		return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Sell Price</h2>} />
        <div className="my-layout">
          <Spin spinning={this.state.loading} tip="Loading...">
            <Content className="main-container">
              <div className='main-container-inner'>
                <Row>
                  <Col sm={24} md={12}></Col>
                  <Col sm={24} md={12}>
                    <DropdownCountry
                      fn={this.mySearch}
                      fnReset={this.resetSearch}
                    />
                  </Col>
                </Row>
              </div>
              <Table {...propsTable} />
              <Table {...propsTableForMobile} />
            </Content>
          </Spin>
          <CountrySellPriceForm
            wrappedComponentRef={this.saveFormRef}
            visible={this.state.visibleFormModal}
            onCancel={this.formHandleCancel}
            onUpdate={this.formHandleSubmit}
            data={this.state.countryData}
          />
        </div>
      </Layout>
		)
	}
}

const CountrySellPriceForm = Form.create({name: "country_sell_price_form"})(
	class extends Component {
    componentDidUpdate = async (prevProps, prevState) => {
      const {data: pd} = prevProps
      const {data: d, form} = this.props

      if (d && (d.client_rate !== pd.client_rate || d.market_rate !== pd.market_rate)) {
      	form.setFieldsValue(d)
      }
    }

    render() {
    	const { visible, onUpdate, onCancel, form, data } = this.props;
      const { getFieldDecorator } = form;
      let title = `Edit Rates: ${data.country_name}`

      return (
        <Modal
          visible={visible}
          title={title}
          okText="OK"
          cancelText="Cancel"
          onCancel={onCancel}
          onOk={onUpdate}
          maskClosable={false}
          style={{ top: 20 }}
        >
          <Form layout="vertical" className="verify_template_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            <Form.Item label="Client Rate">
              {getFieldDecorator('client_rate', {
                rules: [
                  {
                    pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                    message: "Please enter a number and a maximum of 4 decimals only."
                  },
                  { required: true, message: 'Client Rate is required' }
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Market Rate">
              {getFieldDecorator('market_rate', {
                rules: [
                  {
                    pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                    message: "Please enter a number and a maximum of 4 decimals only."
                  },
                  { required: true, message: 'Market Rate is required' }],
              })(<Input />)}
            </Form.Item>
          </Form>
        </Modal>
      )
    }
	}
);

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
  }
}

export default connect(null, mapDispatchToProps)(CountrySellPrice)


// WEBPACK FOOTER //
// ./src/containers/Country/CountrySellPrice.js